// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountGetUsersDefaultResponse {
    static getAttributeTypeMap() {
        return AccountGetUsersDefaultResponse.attributeTypeMap;
    }
}
AccountGetUsersDefaultResponse.discriminator = undefined;
AccountGetUsersDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "Array<ScriptsAccountGetUsersGetUsersResponseModel>"
    }
];
//# sourceMappingURL=accountGetUsersDefaultResponse.js.map